/*jshint esversion: 6 */
export function createElementFromHTML(htmlString) {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim().replace(/(\r\n|\n|\r)/gm, "");
  return div.firstChild;
}
